import React, { useState, useContext } from 'react';
import { Modal, ModalHeader, ModalBody, Badge, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MainTable from '../../components/tables/MainTable';
import { personsServices } from '../../services';
import { SolicitudContext } from './SolicitudContext';
import ClientFormModal from './ClientFormModal';

// allowCreate: muestra "Agregar" para crear el cliente cuando no aparece en la búsqueda
// porCredito: un número también busca al cliente dueño de ese crédito (estado de cuenta)
const ModalSearchClient = ({ show, title, toggle, onSelect, terceros, lawyers, allowCreate, porCredito }) => {
  const context = useContext(SolicitudContext);
  if (!onSelect) {
    var { onSelectClient } = context;
  }
  const [listData, setListData] = useState([]);
  const [loading, setLoading] = useState();
  const [creating, setCreating] = useState(false);
  const [ultimaBusqueda, setUltimaBusqueda] = useState('');

  const columns = [
    {
      dataField: 'terceroInformacion.nombre1',
      text: 'Nombre/Razón social',
      headerClasses: 'border-0',
      classes: 'border-0 py-2 align-middle',
      formatter: (name, row) => nameFormatter(name, row),
      sort: true
    },
    {
      dataField: 'terceroInformacion.identificacion',
      headerClasses: 'border-0',
      text: 'Identificación',
      classes: 'border-0 py-2 align-middle',
      sort: false
    },
    {
      dataField: 'terceroUbicacion.correo',
      headerClasses: 'border-0',
      text: 'Correo',
      classes: 'border-0 py-2 align-middle',
      sort: false
    },
  ];

  const nameFormatter = (name, data) => {
    if (!data) return <></>
    const { nombre2, apellido1, apellido2, nombreComercial, razonSocial } = data.terceroInformacion;
    return razonSocial ? <span>{`${nombreComercial || razonSocial}`}</span> : <span>{`${name} ${nombre2} ${apellido1} ${apellido2}`}</span>
  }

  const handleSearch = async (value) => {
    setUltimaBusqueda(value || '');
    setLoading(true);
    const resp = await personsServices.getByPattern({
      roles: lawyers ? '11' : terceros ? '0' : '1',
      pattern: value,
    })
    if (!resp || resp.error) {
      setLoading(false);
      return;
    }

    let lista = resp.objResponse || [];
    // Con porCredito, un número también se toma como número de crédito: se agrega el cliente dueño
    // del crédito si la búsqueda por nombre o identificación no lo trajo ya.
    const numero = (value || '').trim();
    if (porCredito && /^\d+$/.test(numero)) {
      const credito = await personsServices.getByCredit(numero);
      const faltan = (credito && !credito.error ? credito.objResponse || [] : [])
        .filter(id => !lista.some(t => t.terceroInformacion?.identificacion === id));
      for (const id of faltan) {
        const r = await personsServices.getByPattern({ roles: '1', pattern: id });
        const cliente = r && !r.error && (r.objResponse || []).find(t => t.terceroInformacion?.identificacion === id);
        if (cliente) lista = [cliente, ...lista];
      }
    }

    setListData(lista);
    setLoading(false);
  }

  const handleSelect = (value) => {
    if (onSelect) {
      onSelect(value);
    } else {
      onSelectClient(value);
    }
    setListData([]);
  }

  return (
    <Modal isOpen={show} size="xl" toggle={() => {
      setListData([]);
      toggle();
    }}>
      <ModalHeader
        close={
          <div className='d-flex justify-content-center'>
            <FontAwesomeIcon
              onClick={() => toggle()}
              style={{ cursor: 'pointer' }}
              size='lg'
              icon="times"
            />
          </div>}
      >
        <div className="row pt-3 ">
          <div className="flex col-md-12">
            <h3>{title ? title : terceros ? "Buscar Tercero" : "Buscar Cliente"}</h3>
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <MainTable
          data={listData}
          columns={columns}
          keyField="terceroInformacion.identificacion"
          search={handleSearch}
          className="px-2"
          loading={loading}
          pageSize={10}
          rowClasses="main-table-custom-row"
          handleSelect={{ mode: 'radio', clickToSelect: true, onSelect: handleSelect }}
          noAdd={!allowCreate}
          handleAddNew={() => setCreating(true)}
        />
        {allowCreate && (
          <ClientFormModal
            open={creating}
            mode="crear"
            cedula={/^\d+$/.test(ultimaBusqueda.trim()) ? ultimaBusqueda.trim() : null}
            toggle={() => setCreating(false)}
            onSaved={handleSelect}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

export default ModalSearchClient;
